/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Open_ConversationInputs */

const en_us2_search_open_conversation = /** @type {(inputs: Search_Open_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open with your trainer`)
};

const pt_br2_search_open_conversation = /** @type {(inputs: Search_Open_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir no Personal`)
};

const es_419_search_open_conversation = /** @type {(inputs: Search_Open_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir con tu entrenador`)
};

const pt_pt2_search_open_conversation = /** @type {(inputs: Search_Open_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir no Treinador`)
};

const fr_fr2_search_open_conversation = /** @type {(inputs: Search_Open_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir avec ton coach`)
};

const de_de2_search_open_conversation = /** @type {(inputs: Search_Open_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Coach öffnen`)
};

const it_it2_search_open_conversation = /** @type {(inputs: Search_Open_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri con il tuo coach`)
};

/**
* | output |
* | --- |
* | "Open with your trainer" |
*
* @param {Search_Open_ConversationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_open_conversation = /** @type {((inputs?: Search_Open_ConversationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Open_ConversationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_open_conversation(inputs)
	if (locale === "es-419") return es_419_search_open_conversation(inputs)
	if (locale === "pt-PT") return pt_pt2_search_open_conversation(inputs)
	if (locale === "fr-FR") return fr_fr2_search_open_conversation(inputs)
	if (locale === "de-DE") return de_de2_search_open_conversation(inputs)
	if (locale === "it-IT") return it_it2_search_open_conversation(inputs)
	return en_us2_search_open_conversation(inputs)
});
export { search_open_conversation as "search.open_conversation" }